

































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {CardForm, Table} from '@/components/bwaff';
import CreateApiKeys from './apikeys/create-api-keys.vue';
import {forEach} from 'lodash';
import moment from 'moment-timezone';
import { SecuritylApi } from '@/views/settings/security/api';

@Component({
  components: {
    CardForm,
    DataTable: Table,
    CreateApiKeys
  }
})
export default class ApiKeys extends Vue {

  @Prop()
  api!: SecuritylApi;

  @Prop()
  dataApiKeys!: any;

  @Prop({default:'DD MMM YYYY HH:mm'})
  format!: string;

  rows: any[] = [];
  rowsOnPage: number = 10;

  error: boolean = false;
  error_message: string = '';

  form: object = {};

  pagination: object = {
    rowsPerPage: this.rowsOnPage
  };

  formatters: object = {
    created: (h, value) => {
      if (!value) return null;
      return moment.utc(value).tz(this.$store.state.user.defaultTimezone).format(this.format);
    },
    accessKey: (h, id, context, data) => {
      return h('v-tooltip', { attrs: { top: 'top' } }, [
        h('span', {slot: 'activator'}, data.accessKey),
        h('span', {}, data.accessKey)]);
    },
    accessLevel: (h, id, context, data) => {
      return data.accessLevel === 'readOnly' ? this.t('Read Only') : this.t('Full Access');
    },
    allowUrlAccess: (h, allowed) => {
      return h('ui-icon', {
        props: {
          size: 14,
          color: allowed ? this.$colors.green : this.$colors.red,
          icon: allowed ? 'fas fa-check-circle' : 'fas fa-times-circle',
        }
      });
    },
    latestActivity: (h, id, context, data) => {
      const { remoteAddr, latestActivity } = data.latestActivity;
      if(!remoteAddr && !latestActivity) return null;

      return [
        h('div', [ remoteAddr ]),
        h('div', [`(${moment.utc(latestActivity).fromNow()})`])
      ];
    },
    workspaceIds: (h, id, context, data) => {
      const workspaceIds = data.workspaceIds;
      const allWorkspacesObject = this.$store.getters.allWorkspacesObject;

      if (!workspaceIds || workspaceIds.length === 0) {
        return this.t('All Workspaces');
      }

      const children = [
        h('div', { class: 'onePlus-text' }, allWorkspacesObject[workspaceIds[0]]?.name || '')
      ];

      if (workspaceIds.length > 1) {
        children.push(
          h('v-tooltip', {
            attrs: { top: 'top' },
            props: {
              color: this.$colors.white,
              contentClass: 'onePlus-tooltip',
            },
            class: 'ml-8',
          }, [
            h('div', {
              slot: 'activator',
              class: 'onePlus-text onePlus-text--count',
            }, `+${workspaceIds.length - 1}`),
            ...workspaceIds.slice(1).map((workspaceId: string) =>
              h('div', { class: 'onePlus-text' }, allWorkspacesObject[workspaceId]?.name || '')
            ),
          ])
        );
      }

      return h('div', { class: 'onePlus-wrp' }, children);
    },
    actions: (h, id, context, data) => {
      const canEdit = data.allowUrlAccess;
      return h('div', { class: 'apikey-wr__actions' }, [
        h(
          'a',
          {
            class: ['apikey-wr__action', { 'apikey-wr__action--disabled': !canEdit }],
            style: {
              color: canEdit ? 'var(--color-green)' : 'var(--color-gray40)',
              'font-size': '13px',
            },
            on: {
              click: (e: any) => {
                e.preventDefault();
                if (!canEdit) return;
                this.openEditApiKey(data);
              }
            }
          },
          [
            h('ui-icon', {
              props: {
                size: 12,
                color: canEdit ? this.$colors.green : this.$colors.gray40,
                icon: 'fas fa-pen',
              },
              style: {
                'margin-right': '4px',
                'vertical-align': 'baseline',
              }
            }),
            this.t('Edit')
          ]
        ),
        h(
          'a',
          {
            class: 'apikey-wr__action',
            style: { color: 'var(--color-red)', 'font-size': '13px' },
            on: {
              click: (e: any) => {
                e.preventDefault();
                this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
                  message: this.t('All selected items will be deleted permanently if you press OK.'),
                  onConfirm: () => {
                    this.api.deleteApiKey(data.accessKey).then(() => {
                      this.api.getApiKeys();
                      this.bus.emit('toast-success', this.t('API key deleted.'));
                    });
                  }
                }})
              }
            }
          },
          [
            h('ui-icon', {
              props: {
                size: 12,
                color: this.$colors.red,
                icon: 'fas fa-trash-alt',
              },
              style: {
                'margin-right': '4px',
                'vertical-align': 'baseline',
              }
            }),
            this.t('Delete')
          ]
        )
      ]);
    },
  };

  get headers() {
    return [
      {
        text: this.t('Access Key'),
        align: 'left',
        sortable: false,
        value: 'accessKey'
      },
      {
        text: this.t('Created At'),
        value: 'created',
        align: 'left',
        sortable: false
      }, 
      {
        text: this.t('Last Activity'),
        value: 'latestActivity',
        align: 'left',
        sortable: false
      },
      {
        text: this.t('Access Level'),
        value: 'accessLevel',
        align: 'left',
        sortable: false
      },
      {
        text: this.t('URLs Access'),
        value: 'allowUrlAccess',
        align: 'center',
        sortable: false
      },
      {
        text: this.t('Workspaces'),
        value: 'workspaceIds',
        align: 'left',
        sortable: false
      },
      {
        align: 'right',
        value: 'actions',
        sortable: false
      }
    ];
  }

  get tableRows() {
    if (!this.rows) return [];

    return this.rows;
  }


  @Watch('dataApiKeys')
  dataReceived(data: any) {
    this.rows = forEach(data, e => {
      e.latestActivity = {
        remoteAddr:e.remoteAddr,
        latestActivity:e.latestActivity
      }
      e.workspaceIds = e.workspaceIds;
      e.allowUrlAccess = Boolean(e.allowUrlAccess ?? true);
      e.actions = '';
      return e;
    }).slice().sort((a, b) => moment.utc(b.created).valueOf() - moment.utc(a.created).valueOf());
  }

  openCreateApiKey() {
    this.bus.emit('open-dialog', { name: 'CreateApiKeys', data: { api: this.api } });
  }

  openEditApiKey(apiKey: any) {
    this.bus.emit('open-dialog', { name: 'CreateApiKeys', data: { api: this.api, apiKey } });
  }
}
